import React from "react";
import { Alert } from "design-react-kit";

const Errors = ({ error }) => {
  return error ? <Alert color="danger">{error.message}</Alert> : "";
};

export default Errors;
